import { getConditionalArray } from 'utils/data';
import { logger } from 'utils/logger';

/**
 * Minimal synchronous event emitter shared by the web and native transports.
 *
 * Kept dependency-free (no Node EventEmitter, no third-party lib) so it works
 * identically in the browser bundle and the native WebView. Listeners are stored
 * per event name; `emit` swallows individual listener errors so one bad consumer
 * cannot break call-state propagation.
 */
export const createTransportEmitter = () => {
  const listeners = {};

  const on = (eventName, handler) => {
    listeners[eventName] = [
      ...getConditionalArray(!!listeners[eventName], listeners[eventName]),
      handler,
    ];

    return () => off(eventName, handler);
  };

  const off = (eventName, handler) => {
    listeners[eventName] = getConditionalArray(!!listeners[eventName], () =>
      listeners[eventName].filter(registered => registered !== handler),
    );
  };

  const emit = (eventName, payload) => {
    getConditionalArray(!!listeners[eventName], listeners[eventName]).forEach(handler => {
      try {
        handler(payload);
      } catch (error) {
        logger.warn(`[TelephonyTransport] Listener for "${eventName}" threw`, error);
      }
    });
  };

  return { on, off, emit };
};
